'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp;
// import Collapse from 'react-collapse';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _newMedium = require('redux/modules/newMedium');

var newMediumAction = _interopRequireWildcard(_newMedium);

var _reduxAsyncConnect = require('redux-async-connect');

var _background = require('redux/modules/background');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewMedium = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store;
    var dispatch = _ref$store.dispatch;
    var getState = _ref$store.getState;
    var location = _ref.location;

    var promises = [];
    var query = location.query;
    var filter = '';
    var page = null;
    var orderItem = '';
    var direction = '';
    if (query.shop) {
      filter = (0, _extends3.default)({}, filter, { shopId: query.shop });
    }
    if (query.page) {
      page = query.page;
    }
    if (query.findValue) {
      filter = (0, _extends3.default)({}, filter, { FindValue: query.findValue });
    }
    if (query.orderItem) {
      orderItem = query.orderItem;
    }
    if (query.direction) {
      direction = query.direction;
    }
    promises.push(dispatch((0, _background.changeHeaderText)('新媒体')));
    promises.push(dispatch(newMediumAction.load(filter, {
      orderItem: orderItem,
      direction: direction
    }, newMediumAction.isLoaded(getState()), page)));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.newMedium.data,
    dataError: state.newMedium.error
  };
}, (0, _extends3.default)({}, newMediumAction, {
  routerPush: _reactRouterRedux.push
})), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(NewMedium, _Component);

  function NewMedium() {
    (0, _classCallCheck3.default)(this, NewMedium);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(NewMedium).call(this));

    _this.onWbClick = function () {
      _this.setState({
        isWbOpened: !_this.state.isWbOpened,
        isGzhOpened: false
      });
    };

    _this.onGzhClick = function () {
      _this.setState({
        isGzhOpened: !_this.state.isGzhOpened,
        isWbOpened: false
      });
    };

    _this.state = {
      isWbOpened: false,
      isGzhOpened: true,
      whichShowFlag: ''
    };
    return _this;
  }

  (0, _createClass3.default)(NewMedium, [{
    key: 'onWhichShow',
    value: function onWhichShow(flag) {
      var whichShowFlag = this.state.whichShowFlag;
      // console.log(flag);

      if (flag !== whichShowFlag) {
        this.setState({
          whichShowFlag: flag
        });
      }
    }
  }, {
    key: 'onOrderItemClick',
    value: function onOrderItemClick(val) {
      var _props = this.props;
      var routerPush = _props.routerPush;
      var location = _props.location;

      switch (val) {
        case 'wechat':
          /*
           if (routerPush) {
           if (!location.query.isExperienceGoods || location.query.isExperienceGoods === '0') {
           const currentQuery = {...location.query, isExperienceGoods: '1'};
           if (currentQuery.isExperienceProduct) {
           delete currentQuery.isExperienceProduct;
           }
           if (currentQuery.isAppreciationGoods) {
           delete currentQuery.isAppreciationGoods;
           }
           if (currentQuery.page) {
           delete currentQuery.page;
           }
           routerPush({pathname: location.pathname, query: {...currentQuery}});
           this.scrollToAnchor('homePageOrderBar');
           }
           } */
          break;
        case 'weibo':
          break;
        case 'other':
          break;
        case 'price':
          if (routerPush) {
            var direction = location.query.direction === 'ASC' ? 'DESC' : 'ASC';
            routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, location.query, { orderItem: val, direction: direction }) });
            this.scrollToAnchor('homePageOrderBar');
          }
          break;
        case 'zw':
          break;
        default:
          if (routerPush) {
            var query = {};
            if (location.query.type) {
              query.type = location.query.type;
            }
            routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, query) });
          }
      }
    }
  }, {
    key: 'onSearch',
    value: function onSearch(val) {
      var _props2 = this.props;
      var routerPush = _props2.routerPush;
      var location = _props2.location;

      if (routerPush) {
        var query = {};
        if (val) {
          query.findValue = val;
        }
        routerPush({ pathname: location.pathname, query: query });
      }
    }
  }, {
    key: 'scrollToAnchor',
    value: function scrollToAnchor(anchorName) {
      if (anchorName) {
        var anchorElement = document.getElementById(anchorName);
        if (anchorElement) {
          anchorElement.scrollIntoView();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props;
      var data = _props3.data;
      var location = _props3.location;
      // const {isGzhOpened, whichShowFlag} = this.state;

      var styles = require('./NewMedium.scss');
      var carouselDiv = '';
      var resultListDiv = '';
      var totalPageNumber = 1;
      var currentPage = 0;
      if (data) {
        var newMediumCarousalImgs = data.newMediumCarousalImgs;
        var newMediumCarousalImgsError = data.newMediumCarousalImgsError;
        var newMediumPublicPlatform = data.newMediumPublicPlatform;
        var newMediumPublicPlatformError = data.newMediumPublicPlatformError;
        var newMediumPublicPlatformRecordCount = data.newMediumPublicPlatformRecordCount;
        var newMediumPublicPlatformPagesize = data.newMediumPublicPlatformPagesize;

        if (newMediumCarousalImgsError) {
          carouselDiv = newMediumCarousalImgsError;
        } else if (newMediumCarousalImgs instanceof Array) {
          carouselDiv = _react2.default.createElement(_components.GoeasyCarousel, { page: 'productList', images: newMediumCarousalImgs });
        }
        if (newMediumPublicPlatformError) {
          resultListDiv = newMediumPublicPlatformError;
        } else if (newMediumPublicPlatform instanceof Array && newMediumPublicPlatform.length > 0) {
          resultListDiv = _react2.default.createElement(
            'ul',
            { className: styles.new_right_wx },
            newMediumPublicPlatform.map(function (item, index) {
              return _react2.default.createElement(_components.NewMediumListInfo, { key: index, index: index, data: item });
            })
          );
          if (location.query && !isNaN(parseInt(location.query.page, 10))) {
            currentPage = parseInt(location.query.page, 10);
          }
          totalPageNumber = parseInt(newMediumPublicPlatformRecordCount / newMediumPublicPlatformPagesize, 10);
          if (newMediumPublicPlatformRecordCount % newMediumPublicPlatformPagesize > 0) {
            ++totalPageNumber;
          }
        }
      }
      var orderArray = [{ id: 'wechat', text: '公众号' }, { id: 'weibo', text: '微博' }, { id: 'other', text: '直播' }, { id: 'zw', text: '' }, { id: 'zw', text: '' }, { id: 'zw', text: '' }];
      var middleImages = ['http://tupian.goeasy.cn:9999/yipinwang/third/newmedium_icon_a.png', 'http://tupian.goeasy.cn:9999/yipinwang/third/newmedium_icon_b.png'];
      return _react2.default.createElement(
        'div',
        null,
        carouselDiv,
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.HomePageSearchBar, { placeholderTexts: '', onSearch: this.onSearch.bind(this) }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement('div', { className: styles.new_left }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.ListPageMiddleFlip, { data: middleImages }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement('a', { id: 'homePageOrderBar' }),
        _react2.default.createElement(_components.HomePageOrderBar, { texts: orderArray,
          location: location,
          onItemClick: this.onOrderItemClick.bind(this) }),
        _react2.default.createElement('div', { className: 'clear' }),
        resultListDiv,
        totalPageNumber && totalPageNumber > 1 ? _react2.default.createElement(_components.HomePagingBar, { selected: currentPage, totalPageNumber: totalPageNumber,
          onPageItemClick: this.onPageItemClick.bind(this) }) : ''
      );
    }
  }]);
  return NewMedium;
}(_react.Component), _class2.propTypes = {
  children: _react.PropTypes.object,
  location: _react.PropTypes.object,
  data: _react.PropTypes.object,
  routerPush: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = NewMedium;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/NewMedium/NewMedium.js
 ** module id = 1502
 ** module chunks = 0
 **/